import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { memo, useState } from "react";
import { API_URL } from "../consts";
import { Messaggio } from "../prismaTypes";
import { MyLink } from "../ui/MyLink";
import MessageIcon from "@mui/icons-material/Message";
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

export const UserMsgSidebar = memo(function UserMsgSidebar(props: { close?: () => void }) {
  const { close } = props;
  const [open, setOpen] = useState(false);

  const { isLoading, data } = useQuery<unknown, AxiosError, { messaggi: Messaggio[] }>(
    ["messaggi/onSide"],
    () => axios.get(API_URL + "messaggi/onSide").then((res) => res.data)
  );
  if (isLoading) return <></>;
  if ((data?.messaggi?.length ?? 0) < 1) return <></>;

  return (
    <>
      <ListItemButton onClick={() => setOpen(!open)}>
        <ListItemIcon>
          <MessageIcon />
        </ListItemIcon>
        <ListItemText primary="Comunicazioni" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {data?.messaggi.map((m: Messaggio) => (
            <MyLink
              to={"/app/comunicazioni/" + m.id}
              text={m.titolo}
              close={close}
              icon={<MessageIcon />}
            />
          ))}
        </List>
      </Collapse>
    </>
  );
});
